jQuery(document).ready(function($) {

	var tickerFunc = function() {

		clearTimeout(timer);
		timer = setTimeout(tickerFunc, 5000);

		$(".ticker").each(function() {

			var $this    = $(this);
			var itemList = $this.find('.ticker--items');
			var items    = $this.find('.ticker--item');
			var count    = items.length - 1;
			var showing  = $(this).find('.is-showing').index();
			var next     = showing + 1;

	    if ( next > count ) {
	    	next = 0;
	    }

	    items.removeClass('is-showing').eq(next).addClass('is-showing');

		});

	};

	var timer = setTimeout(tickerFunc, 5000);

});
